// extracted by mini-css-extract-plugin
module.exports = {"link":"Tutorial_link__3SXrS","tutorialContainer":"Tutorial_tutorialContainer__2TBtA"};